<template>
  <v-dialog v-model="dialog" persistent width="max-content" hide-overlay content-class="trips-dialog">

      <div style="position: relative;">
        <div class="close_btn" >
          <v-icon small @click="onClose">close</v-icon>
        </div>
      <div v-if="trips && trips[0]" class="driver">{{ trips[0].driver.id }}_{{ trips[0].driver.name }}</div>

      <div class="no-data" v-else>Pas de transports</div>

      <template v-for="(item, index) in trips"  >

        <v-list-item dense :key="item.id" :class="'type_'+item.type" @click="onShow(item)">
          <v-list-item-action>
            <v-list-item-action-text class="primary--text">{{ item.pickTime | formatTime }}</v-list-item-action-text>

          </v-list-item-action>
          <v-list-item-content >
            <v-list-item-title v-text="item.client.name"></v-list-item-title>
            <v-list-item-subtitle>
              <span v-if="item.type !== 'back'" >{{ item.ap_time | formatTime }}</span> <span class="black--text"> {{ item.destination.name }}</span>
            </v-list-item-subtitle>
          </v-list-item-content>
            <v-list-item-action>
            <v-icon v-if="item.charged" color="green">
              person
            </v-icon>
            </v-list-item-action>
          <v-list-item-action>
            <v-icon small
              v-if="item.type === 'back'"
            >
              arrow_back
            </v-icon>

            <v-icon small
              v-else

            >
              arrow_forward
            </v-icon>

          </v-list-item-action>
        </v-list-item>
           <v-divider width="100%"
            v-if="index < trips.length - 1"
            :key="index"
          ></v-divider>
      </template>

      </div>
  </v-dialog>
</template>
<script>
export default {
  name: 'TripsList',
  props: ['dialog', 'trips'],
  mixins: [],
  data () {
    return {};
  },
  methods: {
    onClose () {
      console.log('onClose');
      this.$emit('close');
    },
    onShow (item) {
      this.$emit('show', item)
    }
  },
  mounted () {}
};
</script>
<style lang="scss">
.v-dialog.trips-dialog {
  background: white;
  border-radius: 10px;
  border: solid 1px rgb(224, 223, 223);
  .no-data {
    text-align: center;
    font-size: .875rem;
    padding: 16px;
    min-width: 150px;
  }
  .close_btn {
      width: initial !important;
      position:absolute;
      display: inline;
      right: 4px;
      color: white;
  }
  .driver {
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: .875rem;
    padding: 0 16px;
    color: $primary;
    height: 30px;
    background-color: white;
    border-bottom: solid 1px rgb(221, 220, 220);

  }
  .v-list-item {
    position:static;
    &.type_back {
      background-color: rgba($primary, .2);
    }
    &.type_simple {
      background-color: #d5ddf6d2;
    }
    .v-list-item__action {
      margin: 4px 0;
      margin-right: 24px;
    }
    .charged {
       background-color: rgba(16, 199, 10, 0.214);
    }
  }
}
</style>
